// src/pages/DentalNews/DentalRoutes.js
import React from "react";
import { Routes, Route } from "react-router-dom"; 
import DentalLabJournalPage from "./pages/DentalLabJournalPage";
import DentalNews from "./pages/DentalNews";
import DentalNewsPosts from "./pages/DentalNewsPosts";

const DentalRoutes = () => {
  return (
    <Routes>
      <Route path="/journal" element={<DentalLabJournalPage/>} />
      <Route path="/news" element={<DentalNews/>} />

      
      {/* FIXED: This route should match the sidebar navigation */}
      <Route path="/:id/posts" element={<DentalNewsPosts/>} />
    </Routes>
  );
};

export default DentalRoutes;